import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { AnswerAreaComponent } from 'src/app/questions/answer-area/answer-area.component';
import { Subscription } from 'rxjs';

declare var decimalInput: any;

@Component({
  selector: 'app-matrixnote',
  templateUrl: './matrixnote.html',
  styleUrls: ['./matrixnote.scss']
})

export class MatrixNote implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public answers = [];
  public headers = [];
  public rows = [];
  public rowTitles = [];
  public rowTypes = [];
  public rowHeaderData = [];
  public rowdatacount = 0;

  private loadAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.loadAnswersSubscription = this.dataSvc.getLoadMatrixNoteAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  resetVariables(){
    this.answers = [];
    this.headers = [];
    this.rows = [];
    this.rowTitles = [];
    this.rowTypes = [];
    this.rowHeaderData = [];
    this.rowdatacount = 0;
  }
  
  loadAnswers() {
    this.resetVariables();
    if(this.dataSvc.currentQuestion.Question.QuestionType !== 15) return;

    var currentQuestion = this.dataSvc.currentQuestion;
    //console.log(currentQuestion);
    var response = currentQuestion.QuestionResponses[0].Response;
    if(response !== null && response !== undefined){
      this.rows = response.AnswerText.split(",");
            
      for(var r = 0; r < this.rows.length; r++){
        var rowData = this.rows[r].split("+");
        this.rowTitles.push(rowData[0]);

        var rowInfo = rowData[1].split("*");
        for(var i = 0; i < rowInfo.length; i++){
          this.rowTypes.push(rowInfo[i])
        }
      }

      //console.log(this.rowTitles);
      //console.log(this.rowTypes);
      
      

      this.headers = response.QuestionText.split(",");
    }

    setTimeout(() => {
      var responseText = currentQuestion.Result.Selection;
      if(responseText !== null && responseText !== undefined && responseText !== ""){
        var rt = responseText.split(",");
        if(rt.length > 0){
          for(var r = 0; r < rt.length; r++){
            var inputs = document.getElementsByClassName("matrixNoteInput");
            var answer = rt[r].split("||");
            if(answer.length == 2){
              for (var i = 0; i < inputs.length; i++) {
                var element = (<HTMLInputElement>inputs[i]);
                var row = parseInt(element.getAttribute("data-rowindex"));
                var header = parseInt(element.getAttribute("data-headerindex"));
  
                if(answer[0] == "lbMatrixNoteRow" + (row + 1) +"Col" + (header + 1)){
                  element.value = answer[1];
                }
              }
            }
          }
        }
      }
    },100);    
  }

  updateAnswers(){
    this.answers.length = 0;
    var inputs = document.getElementsByClassName("matrixNoteInput");
    for (var i = 0; i < inputs.length; i++) {
      var element = (<HTMLInputElement>inputs[i]);        
      var input = element.value;
      var row = parseInt(element.getAttribute("data-rowindex"));
      var header = parseInt(element.getAttribute("data-headerindex"));

      var answer = "lbMatrixNoteRow" + (row + 1) +"Col" + (header + 1) + "||" + input;
      this.answers.push(answer);
    } 
    this.dataSvc.currentQuestion.Result.Selection = this.answers.join(",");
  }

 
}
